import { useEffect } from "react";
import {
    addSubscriber,
    removeSubscriber,
} from "@infrastructure/Events/EventBus";
import { getOnReactionEventName } from "../Events/OnReactionEvent";
import { OnReactionEventHandler } from "../Events/OnReactionEvent.types";
import { ReactionEntityName } from "../Reactions.types";

export const useOnReaction = (
    entityName: ReactionEntityName,
    callback: OnReactionEventHandler,
) => {
    useEffect(() => {
        const reactionSubscriber = addSubscriber(
            getOnReactionEventName(entityName),
            (notification) => callback(notification.body),
        );

        return () => {
            removeSubscriber(reactionSubscriber);
        };
    }, [callback, entityName]);
};
